var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 46,
    viewBox: "0 0 34 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_11297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 2.23858 6.23858 0 9 0H30V38H9C6.23858 38 4 35.7614 4 33V5Z",
    fill: "#FBC548"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2752 11.2749C18.4585 11.4582 18.5545 11.6916 18.5632 11.9749C18.5719 12.2582 18.4842 12.4916 18.3002 12.6749L13.4002 17.5749L24.5752 17.5749C24.8585 17.5749 25.0962 17.6709 25.2882 17.8629C25.4802 18.0549 25.5759 18.2922 25.5752 18.5749C25.5752 18.8582 25.4792 19.0959 25.2872 19.2879C25.0952 19.4799 24.8579 19.5756 24.5752 19.5749L13.4002 19.5749L18.3002 24.4749C18.4835 24.6582 18.5712 24.8916 18.5632 25.1749C18.5552 25.4582 18.4592 25.6916 18.2752 25.8749C18.0919 26.0582 17.8585 26.1499 17.5752 26.1499C17.2919 26.1499 17.0585 26.0582 16.8752 25.8749L10.2752 19.2749C10.1752 19.1916 10.1042 19.0872 10.0622 18.9619C10.0202 18.8366 9.99952 18.7076 10.0002 18.5749C10.0002 18.4416 10.0209 18.3166 10.0622 18.1999C10.1035 18.0832 10.1745 17.9749 10.2752 17.8749L16.8752 11.2749C17.0585 11.0916 17.2919 10.9999 17.5752 10.9999C17.8585 10.9999 18.0919 11.0916 18.2752 11.2749Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_11297",
    x: 0,
    y: 0,
    width: 34,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_11297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_11297",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f59f906b72561b1087b5f4d8bdb8b783.svg";
export { ForwardRef as ReactComponent };